var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFishik(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 144,
    height: 155,
    viewBox: "0 0 144 155",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.528 81.598C56.5668 88.6452 44.0643 102.265 47.3219 107.311C48.5619 109.234 51.8523 109.586 57.4957 110.057C63.9168 110.597 69.2697 109.893 72.9243 109.157C73.7141 108.228 75.7972 106.05 78.9156 105.711C78.9156 105.711 81.453 105.437 84.1581 106.91C88.7621 109.418 89.7852 127.388 87.6039 150.945C79.0712 155.684 69.8877 154.01 66.3354 148.849C62.9469 143.926 65.4719 136.969 65.7379 136.269C67.6614 131.178 71.6229 128.645 72.9284 127.884C72.2777 124.79 71.6311 121.692 70.9804 118.598C67.6532 119.408 62.5417 120.329 56.3007 120.096C52.1592 119.94 39.3171 119.298 35.331 113.654C30.2646 106.484 38.0566 89.1322 56.2475 72.2754C58.6744 75.3816 61.1053 78.4918 63.5321 81.598H63.528Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.94094,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M75.3281 85.9863C64.9374 103.662 54.5426 121.333 44.1518 139.008C45.2936 139.765 47.082 141.173 48.4939 143.502C50.933 147.52 50.6138 151.564 50.4419 152.939H2.96129C1.96682 150.643 -0.619621 143.829 2.36378 138.411C6.47669 130.938 20.301 127.721 34.3831 135.084C44.0659 118.718 53.7486 102.352 63.4314 85.9863H75.3281Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.94094,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M75.8047 83.7207C71.0493 84.5515 66.2897 85.3781 61.5343 86.2089C61.0064 88.1365 60.4825 90.064 59.9546 91.9916C63.0649 93.3216 66.1751 94.6476 69.2813 95.9776C71.4544 91.8933 73.6275 87.805 75.8006 83.7207H75.8047Z",
    fill: "#1E1E1E",
    stroke: "#1E1E1E",
    strokeWidth: 1.94094,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M52.1964 94.3938L40.6066 90.4037L44.8381 83.7207L57.2383 87.6454L52.1964 94.3938Z",
    fill: "#1E1E1E",
    stroke: "#1E1E1E",
    strokeWidth: 1.94094,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M103.539 40.6181C93.5125 22.0342 74.2084 11.3447 55.1703 13.6529C40.4129 15.4413 21.3257 25.5824 17.7243 44.8087C14.3603 62.7664 26.2162 79.525 39.4553 86.3103C58.9476 96.3041 87.5661 87.8122 103.539 62.8933C104.562 64.7676 110.828 75.7927 124.153 78.9357C132.866 80.9901 140.056 78.6083 142.904 77.4829C139.491 73.2472 133.283 64.3788 130.77 51.4426C127.844 36.3496 131.601 24.2319 133.528 19.104C130.402 19.2554 126.191 19.8734 121.673 21.8623C110.021 26.982 104.967 37.3768 103.543 40.6262L103.539 40.6181Z",
    fill: "#5B5BD8",
    stroke: "#1E1E1E",
    strokeWidth: 1.94094,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6369 50.0136C13.6369 43.2104 19.1519 37.6953 25.9552 37.6953C32.7584 37.6953 38.2734 43.2104 38.2734 50.0136V52.2358C38.2734 59.039 32.7584 64.5541 25.9552 64.5541C19.1519 64.5541 13.6369 59.039 13.6369 52.2358V50.0136Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.94094,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5114 59.3208C17.4488 59.3208 14.9661 55.7919 14.9661 51.4387C14.9661 47.0856 17.4488 43.5566 20.5114 43.5566C23.5739 43.5566 26.0566 47.0856 26.0566 51.4387C26.0566 55.7919 23.5739 59.3208 20.5114 59.3208Z",
    fill: "#1E1E1E",
    stroke: "#1E1E1E",
    strokeWidth: 1.94094,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3901 61.6976L20.2743 55.4648L27.5098 56.6517L22.3901 61.6976Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8701 47.635C14.1648 46.3581 15.0897 43.1824 17.9994 40.7515C21.7031 37.6576 27.5185 36.7081 32.2084 39.4582C37.9706 42.8386 38.2612 49.583 38.2734 50.0086C30.1376 49.2147 22.0059 48.4248 13.8701 47.6309V47.635Z",
    fill: "#5B5BD8",
    stroke: "#1E1E1E",
    strokeWidth: 1.94094,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M34.588 49.6972C34.588 42.894 40.1031 37.3789 46.9063 37.3789C53.7095 37.3789 59.2246 42.894 59.2246 49.6972V51.9194C59.2246 58.7226 53.7095 64.2377 46.9063 64.2377C40.1031 64.2377 34.588 58.7226 34.588 51.9194V49.6972Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.94094,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4625 59.0083C38.4 59.0083 35.9173 55.4793 35.9173 51.1262C35.9173 46.7731 38.4 43.2441 41.4625 43.2441C44.5251 43.2441 47.0078 46.7731 47.0078 51.1262C47.0078 55.4793 44.5251 59.0083 41.4625 59.0083Z",
    fill: "#1E1E1E",
    stroke: "#1E1E1E",
    strokeWidth: 1.94094,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3354 61.3812L41.2196 55.1484L48.4551 56.3352L43.3354 61.3812Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8213 47.3244C35.116 46.0476 36.0409 42.8718 38.9506 40.4409C42.6543 37.347 48.4696 36.3976 53.1596 39.1477C58.9218 42.5281 59.2123 49.2724 59.2246 49.698C51.0888 48.9041 42.9571 48.1143 34.8213 47.3203V47.3244Z",
    fill: "#5B5BD8",
    stroke: "#1E1E1E",
    strokeWidth: 1.94094,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M54.1756 33.6249L44.7512 32.0207C42.5231 31.6414 41.0243 29.5277 41.4035 27.2996L41.4042 27.2955C41.7835 25.0674 43.8972 23.5686 46.1253 23.9478L55.5498 25.552C57.7779 25.9313 59.2767 28.045 58.8975 30.2731L58.8968 30.2772C58.5175 32.5053 56.4038 34.0041 54.1756 33.6249Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.94094,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6642 26.0819L25.0886 24.4777C27.3168 24.0985 29.4305 25.5973 29.8098 27.8254L29.8105 27.8295C30.1897 30.0576 28.6909 32.1714 26.4627 32.5506L17.0383 34.1548C14.8102 34.5341 12.6964 33.0352 12.3172 30.8071L12.3165 30.8031C11.9372 28.5749 13.436 26.4612 15.6642 26.0819Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.94094,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0219 67.1824C33.6962 66.7977 30.5941 67.3543 30.2585 68.6311C29.9434 69.822 32.092 71.4058 33.0864 72.081C31.8955 73.452 31.2244 75.1095 31.7564 76.1489C32.4644 77.5445 35.5051 78.1788 38.7422 76.3372",
    stroke: "#1E1E1E",
    strokeWidth: 1.94094,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M70.6302 47.7012C78.5205 50.7091 86.4066 53.7171 94.2969 56.7291C92.8236 60.5965 90.6464 62.7778 89.2468 63.9155C83.1368 68.8796 73.409 68.9001 64.5202 64.1324",
    stroke: "#1E1E1E",
    strokeWidth: 1.94094,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M91.252 60.6171C90.6995 60.6131 68.7803 53.5781 68.7803 53.5781",
    stroke: "#1E1E1E",
    strokeWidth: 1.94094,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M84.8789 65.9193L65.7835 59.4082",
    stroke: "#1E1E1E",
    strokeWidth: 1.94094,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7115 15.4222C51.8562 11.5017 51.0049 7.58109 50.1496 3.65642C62.0464 -1.30363 75.0645 0.730319 83.0038 8.69423C89.5231 15.2381 90.4275 23.5949 90.6035 26.4473",
    fill: "#5B5BD8"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7115 15.4222C51.8562 11.5017 51.0049 7.58109 50.1496 3.65642C62.0464 -1.30363 75.0645 0.730319 83.0038 8.69423C89.5231 15.2381 90.4275 23.5949 90.6035 26.4473",
    stroke: "#1E1E1E",
    strokeWidth: 1.94094,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M60.691 2.00781C61.2517 6.48086 61.8124 10.9539 62.373 15.427L60.691 2.00781Z",
    fill: "#5B5BD8"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M60.691 2.00781C61.2517 6.48086 61.8124 10.9539 62.373 15.427",
    stroke: "#1E1E1E",
    strokeWidth: 1.94094,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M80.9137 7.70312C81.4744 12.1762 82.035 16.6492 82.5957 21.1223L80.9137 7.70312Z",
    fill: "#5B5BD8"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M80.9137 7.70312C81.4744 12.1762 82.035 16.6492 82.5957 21.1223",
    stroke: "#1E1E1E",
    strokeWidth: 1.94094,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M70.7985 2.73828C71.3591 7.21133 71.9198 11.6844 72.4805 16.1574L70.7985 2.73828Z",
    fill: "#5B5BD8"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M70.7985 2.73828C71.3591 7.21133 71.9198 11.6844 72.4805 16.1574",
    stroke: "#1E1E1E",
    strokeWidth: 1.94094,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M103.536 62.8919C104.571 61.3818 105.713 59.4542 106.708 57.1052C107.522 55.1899 108.062 53.4097 108.431 51.875L111.201 72.2759C109.658 70.9458 107.899 69.1984 106.192 66.9557C105.112 65.5315 104.236 64.1565 103.532 62.896L103.536 62.8919Z",
    fill: "#1E1E1E",
    stroke: "#1E1E1E",
    strokeWidth: 1.94094,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFishik);
export default __webpack_public_path__ + "static/media/fishik.eccc445d7e63ea669d8c68b72978faba.svg";
export { ForwardRef as ReactComponent };